import React, { useState } from "react";
import { Button, Card, CardContent, TextField } from "@mui/material";
import { login } from "../../services/authService";

import AuthLayout from "../Common/AuthLayout";
import AuthHeaderLogo from "../Common/AuthHeaderLogo/AuthHeaderLogo";
import { Link } from "react-router-dom";

import ErrorSnackbar from "../Common/Snackbar/ErrorSnackbar";

export default function Login() {
    const [username, setUsername] = useState("");

    return (
        <AuthLayout>
            <div className="form auth-card-container login">
                <form>
                    <Card className="card" data-cy="card_sign-in">
                        <AuthHeaderLogo />
                        <CardContent>
                            <div className="auth-title">
                                <h2>Centric</h2>
                                <p>Sign in to your account</p>
                            </div>
                            <div className="auth-form">
                                <div className="form-row">
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="email"
                                        label="Email"
                                        id="email"
                                        data-cy="username-input"
                                        autoComplete="email"
                                        autoFocus
                                        onChange={(e) =>
                                            setUsername(
                                                e.currentTarget.value.trim()
                                            )
                                        }
                                        value={username}
                                    />
                                </div>
                                <div className="form-action">
                                    <Button
                                        fullWidth
                                        data-cy="signin-button"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => login(username)}
                                        disableElevation={true}
                                        disabled={!username}
                                    >
                                        Sign In
                                    </Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card>

                    <div className="auth-form-links">
                        <ul className="footer-links">
                            <li>
                                <Link to="/resetpassword">Forgot password</Link>
                            </li>
                        </ul>
                    </div>
                </form>
                <ErrorSnackbar />
            </div>
        </AuthLayout>
    );
}
